<template>
  <el-card class="fullTruthModelTest">
    <!-- <el-button type="primary" class="fullTruthModelTest-button1" @click="addExam">添加考试</el-button> -->
    <div class="fullTruthModelTest-box">
      <div class="fullTruthModelTest-button2" @click.stop="goTestPaperSetting">考试设置</div>
      <div class="fullTruthModelTest-button2 bgcolor" @click.stop="goExamStudent">考试学员</div>
      <div class="fullTruthModelTest-button2" @click.stop="goTestPaperManage">考试结果</div>
      <div class="fullTruthModelTest-button2 bgcolor" @click.stop="goPaperManger">考卷管理</div>
      <div class="fullTruthModelTest-button2" @click.stop="goExamRequire">考证要求</div>
      <div class="fullTruthModelTest-button2 bgcolor" @click.stop="goExamManger">证书管理</div>
    </div>
    <el-dialog class="addDialog" title="添加考试" width="500px" :visible.sync="showAddDialog">
      <el-form :model="addForm" status-icon :rules="rules" ref="addForm" label-width="80px">
        <el-form-item label="考试科目" prop="courseIds">
          <el-cascader clearable style="width:100%" v-model="addForm.courseIds" :show-all-levels="false" :props="subjectTreeProps" placeholder="请选择考试科目" :options="subjectTreeList" @change="subjectChange(addForm.courseIds)"></el-cascader>
        </el-form-item>
        <el-form-item label="考试期数">
          <el-input v-model="sequence" disabled></el-input>
        </el-form-item>
        <el-form-item label="报名时间" prop="date">
          <el-date-picker style="width:100%" v-model="addForm.date" type="datetimerange" :picker-options="pickerOptions" range-separator="至" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" start-placeholder="开始日期" end-placeholder="结束日期" align="right"></el-date-picker>
        </el-form-item>
        <el-form-item label="考试时间" prop="examTime">
          <el-row>
            <el-col :span="11">
              <el-date-picker style="width:100%" v-model="addForm.examTime" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date" placeholder="选择日期"></el-date-picker>
            </el-col>
            <el-col :span="12" style="float:right">
              <el-time-picker style="width:100%" is-range value-format="HH:mm" format="HH:mm" v-model="addForm.period" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围"></el-time-picker>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item style="text-align:right">
          <el-button @click="clearForm">取消</el-button>
          <el-button type="primary" @click="addExamSetting">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </el-card>
</template>
<script>
export default {
  data () {
    return {
      showAddDialog: false,
      addForm: {},
      sequence: "",
      subjectTreeList: [],
      examSettingList: [],
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children"
      },
      pickerOptions: {
        disabledDate (time) {
          var times = Date.now() - 24 * 60 * 60 * 1000;
          return time.getTime() < times;
        }
      },
      rules: {
        courseIds: [
          {
            required: true,
            message: "请选择考试课程",
            trigger: "change"
          }
        ],
        sequence: [
          {
            required: true,
            message: "请选择考试期数",
            trigger: "change"
          }
        ],
        examTime: [
          {
            required: true,
            message: "请选择考试时间",
            trigger: "change"
          }
        ],
        date: [
          {
            required: true,
            message: "请选择报名时间",
            trigger: "change"
          }
        ]
      }
    };
  },
  methods: {

    goTestPaperSetting () {
      this.$router.push({ path: "/examSetting" });
    },

    goExamStudent () {
      this.$router.push({ path: "/systemExamStudent" });
    },

    goTestPaperManage () {
      this.$router.push({ path: "/systemExamResult" });
    },

    goPaperManger () {
      this.$router.push({ path: "/testPaperManage" });
    },
    goExamRequire () {
      this.$router.push({ path: "/paperRequire" });
    },
    goExamManger () {
      this.$router.push({ path: "/paperManger" });
    },
    addExam () {
      this.getSubjectCourseExamCount();
      this.showAddDialog = true;
    },
    clearForm () {
      this.showAddDialog = false;
      this.addForm = {};
    },
    addExamSetting () {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.addForm.courseId = this.addForm.courseIds[2];
          this.addForm.examBeginTime =
            this.addForm.examTime + " " + this.addForm.period[0];
          this.addForm.examEndTime =
            this.addForm.examTime + " " + this.addForm.period[1];
          this.addForm.signBeginTime = this.addForm.date[0];
          this.addForm.signEndTime = this.addForm.date[1];
          this.api.examSetting
            .addExamSetting(this.addForm)
            .then(result => {
              if (result.success) {
                this.showAddDialog = false;
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        }
      });
    },
    getSubjectCourseExamCount () {
      this.api.examSetting
        .getSubjectCourseExamCount()
        .then(result => {
          if (result.success) {
            this.subjectTreeList = result.data;
          } else {
            this.$message.error(result.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    subjectChange (item) {
      if (typeof item == "object") {
        this.generateSequence(item[2]);
        // this.addForm.sequence = "";
      }
    },
    generateSequence (courseId) {
      this.api.examSetting
        .generateSequence({ courseId: courseId })
        .then(result => {
          if (result.success) {
            this.addForm.sequence = result.data;
            this.sequence = "第" + this.addForm.sequence + "期";
          } else {
            this.$message.error(result.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    getExamSettingList (courseId) {
      this.api.examSetting
        .getExamSettingList({ courseId: courseId })
        .then(result => {
          if (result.success) {
            this.examSettingList = result.data;
          } else {
            this.$message.error(result.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  watch: {
    showAddDialog: function (newVal) {
      if (!newVal) {
        this.$refs.addForm.resetFields();
        this.sequence = "";
      } else {
      }
    },
  },
  mounted () { }
};
</script>
<style scoped>
.fullTruthModelTest {
  min-height: calc(100% - 40px);
}
.fullTruthModelTest-button1 {
  float: right;
}
.fullTruthModelTest-box {
  text-align: center;
  display: flex;
  min-width: 700px;
  max-width: 1050px;
  margin: auto;
  margin-top: 60px;
  justify-content: center;
  flex-flow: row wrap;
  align-items: center;
}
.fullTruthModelTest-button2 {
  border-radius: 10px;
  height: 160px;
  width: 290px;
  background-color: rgb(77, 148, 255);
  line-height: 160px;
  text-align: center;
  color: #fff;
  font-size: 20px;
  margin: 30px;
  cursor: pointer;
}
.bgcolor {
  background: rgba(77, 148, 255, 0.6);
}
</style>



// WEBPACK FOOTER //
// src/components/testSystem/index.vue